import { render } from "./FormImages.vue?vue&type=template&id=09c0b49c&ts=true"
import script from "./FormImages.vue?vue&type=script&lang=ts"
export * from "./FormImages.vue?vue&type=script&lang=ts"

import "./FormImages.vue?vue&type=style&index=0&id=09c0b49c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__